import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=551a97dc&"
import script from "./InfoPopup.vue?vue&type=script&lang=js&"
export * from "./InfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports